import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth';
import { PermisosService } from '../services/permisos.service';

export const adminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const permisos = inject(PermisosService);

  const user = auth.currentUser();
  if (user?.esAdmin || user?.roles?.includes('admin')) {
    return true;
  }
  // Mismo destino y toast que permissionGuard (ver permission.guard.ts) — antes
  // navegaba directo a '/' en silencio, comportamiento distinto del resto de rutas
  // protegidas (que muestran la pantalla de Acceso denegado en /sin-acceso).
  permisos.denegarAccesoMensaje('No tienes permiso de administrador para acceder a esta sección.');
  return router.createUrlTree(['/sin-acceso']);
};
